// Source: app/scripts/services/messages-service.js
/**
 * Messages service for notification messages using toaster module
 */
Auction.factory('Messages', ['toaster', '$filter',
  function (toaster, $filter) {
    var pop = function (type, title, message) {
      var translatedMessage = "";
      if (angular.isDefined(message)) {
        var messageParts = message.split(" ");
        for (var i = 0; i < messageParts.length; i++) {
          translatedMessage += $filter('translate')(messageParts[i]) + " ";
        }
      }
      toaster.pop(type,
        $filter('translate')(title),
        $filter('translate')(translatedMessage));
    }
    return {
      success: function (title, message) {
        pop('success', title, message);
      },
      error: function (title, message) {
        pop('error', title, message);
      },
      warning: function (title, message) {
        pop('warning', title, message);
      },
      note: function (title, message) {
        pop('note', title, message);
      },
      saved: function () {
        pop('success', 'generic.save_success', 'generic.record_was_saved_successfully');
      },
      deleted: function () {
        pop('success', 'generic.delete_success', 'generic.record_was_deleted_successfully');
      },
      approved: function () {
        pop('success', 'generic.approve_success', 'generic.records_was_successfully_approved');
      },
      disapproved: function () {
        pop('danger', 'generic.disapproved_success', 'generic.records_was_successfully_disapproved');
      }

    }
  }
]);
